module.exports = __webpack_public_path__ + "img/4.a17f0f06.jpg";